import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  body {
    background: #fefefe;
    color: #5e5e5e;
    -webkit-font-smoothing: antialised;
  }

  body, input, button, textarea {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
  }

  h1, strong {
    font-weight: 500;
  }
  h2 {
    font-weight: 400;
  }

  h3,h4,h5,h6 {
    font-weight: 300;
  }

  h3 {
    font-size: 1.125rem;
  }

  button {
    cursor: pointer;
  }
`;
